import { MoreHorizontal, RefreshCcw, Save, Trash, X } from "react-feather";
import { EventDTO } from "../../DTO/EventDTO";
import { ObjectKind } from "../../models/objectKinds";
import mainservice from "../../../services/MainService";
import { DisplayDateFromString } from "../../../services/DateTime";
import { TagSelector } from "../tags/TagSelector";
import { TagDTO } from "../../DTO/TagDTO";
import PersonList from "../Person/PersonList";
import { PersonKind } from "../Person/PersonKind";
import { EventTagDisplay } from "../Person/Person";
import { CompactType } from "../../DTO/BuildingBlocksDTO";
import './DisplayEvent.scss'
import { Alert, Box, SpeedDial, SpeedDialAction } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import InlineMenu from "../../elements/InlineMenu";

export function DisplayEvent(props: {
  item: EventDTO,
  className?: string,
  onClick?: (id: number, item: EventDTO) => void,
  onRemove?: () => void,
  onTrash?: () => void,
  onUntrash?: () => void,
  onDublicate?: () => void,
  onDublicateAsDesign?: () => void,
  compact?: CompactType,
  personId?: number,
}) {
  const item = props.item;
  function onClick () {
    if (props.onClick) {
      return props.onClick(item.id, item);
    }
    mainservice.navTo([['view', item.objectKind === ObjectKind.event ? 'spVeranstaltungsDetails' : 'spVeranstaltungsDesigner'], ['id', item.id]]);
  }
  const veranstaltungsnummer = item.getPropV1('data', 'uniqueEventId')
  return <div
    className={`DisplayEvent PTListItem justify-content-space-between ${item.getFirstTagNameByKind('contractState')}`}
    >
    <div
      className={`pointer ${props.compact ? 'w3-padding' : ''} eventFirstColumn`}
      onClick={onClick}
      style={{paddingLeft: '16px'}}
    >
      {((props.compact !== 'name' && props.compact !== 'participated') && (item.startdate || item.enddate)) &&
        <Box
          sx={{
            marginBottom: '8px',
          }}
        >
          <div>{DisplayDateFromString(item.startdate )} bis {DisplayDateFromString(item.enddate )}</div>
        </Box>
      }
      <Box
        sx={{
            marginBottom: '8px',
            fontWeight: 'bold',
          }}
        className={`EventName ${props.className || ''}`}
      >
        {[item.titlePrefix, item.name, item.titleSuffix].filter(i => i).join(' ')}
      </Box>
      {
        item.objectKind === ObjectKind.event && veranstaltungsnummer &&
        <Box
          sx={{
            fontSize: '0.8125rem',
          }}
        >
          #{veranstaltungsnummer}
        </Box>
      }
    </div>
    {
      props.compact === 'staffEvents' &&
      <div>
        {
          item.getParticipants().map((person, index) => {
            return <div key={`item-${item.id}-participant-${person.id}`}>
              <a
                href={`/view=spPersonEdit/id=${person.id}/`}
                className='w3-hover-text-grey'
                onClick={(e) => {
                  e.preventDefault()
                  mainservice.navTo([['view', 'spPersonEdit'], ['id', person.id]])
                }}
              >
                {person.getDisplayName()}
              </a>
            </div>
          })
        }
      </div>
    }
    {
      (props.compact === 'participated' || props.compact === 'noCompany') &&
      <div className='w3-padding eventDate'>
        {DisplayDateFromString(item.startdate )} bis {DisplayDateFromString(item.enddate )}
      </div>
    }
    {
      props.personId &&
      <EventTagDisplay
        className='w3-padding participation'
        personId={props.personId}
        event={item}
      />
    }
    
    
    {
      (!props.compact || props.compact === 'staffEvents' || props.compact === 'noCompany') &&
      <>
          { item.objectKind === ObjectKind.event &&
            <Box className='hide-on-gantt flex'>
              <TagSelector
                kind={"contractState"}
                mode={"single"}
                selectedTags={item.getTagsByKind("contractState", item.appointmentKey)}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, !item.appointmentKey, item.appointmentKey);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />
              
            </Box>
          }
          { item.objectKind === ObjectKind.event &&
            <div className='hide-on-gantt'>
              <TagSelector
                kind={"eventKind"}
                mode={"single"}
                selectedTags={item.getTagsByKind("eventKind")}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, single);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />  
            </div>
          }
          { item.objectKind === ObjectKind.event &&
            <div className='hide-on-gantt'>
              <TagSelector
                kind={"billingStatus"}
                mode={"single"}
                selectedTags={item.getTagsByKind("billingStatus")}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, single);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />
              
            </div>
          }
          { item.objectKind === ObjectKind.event && false &&
            <div className='hide-on-gantt'>
              <TagSelector
                kind={"priorityA"}
                mode={"single"}
                selectedTags={item.getTagsByKind("priorityA")}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, single);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />  
            </div>
          }
          { item.objectKind === ObjectKind.seminar &&
            <div>
              <TagSelector
                kind={"subjectTags"}
                mode={"list"}
                selectedTags={item.getTagsByKind("subjectTags")}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, single);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />  
            </div>
          }
          { item.objectKind === ObjectKind.seminar &&
            <div>
              <TagSelector
                kind={"workStateTag"}
                mode={"single"}
                selectedTags={item.getTagsByKind("workStateTag")}
                parentId={item.id}
                selectTag={(tag: TagDTO, single: boolean) => {
                  item.setTag(tag, single);
                }}
                unsetTag={(tag: TagDTO) => {
                  item.unsetTag(tag);
                }}
                readMode={false}
                showLabel={false}
              />  
            </div>
          }
          {(item.objectKind === ObjectKind.event) &&
            <Box className="eventDisplayCustomer">
              {
                (props.compact !== 'noCompany' && props.compact !== 'staffEvents') &&
                <Box
                  sx={{
                    marginBottom: '8px'
                  }}
                >
                  {item.customerName ? <Box
                    sx={{padding: '16px'}}
                  >{item.customerName}</Box> : <Alert
                    severity="info"
                  >Kein Unternehmen</Alert>}
                </Box>
              }
              <PersonList
                eventId={item.id}
                className=' '
                noSearch={true}
                personKind={PersonKind.principal}
                propTrainerTagParent={item}
                compact={'yes'}
                noCount={true}
                prefix={'Auftraggeber*in: '}
                persons={item.principal ? [item.principal] : []}
                noContentMsg={'Keine Ansprechpartner*in'}
              />
            </Box>
          }
          {item.objectKind === ObjectKind.event &&
            <div>
              <PersonList
                eventId={item.id}
                className='flex'
                noSearch={true}
                personKind={PersonKind.trainer}
                propTrainerTagParent={item}
                compact={'bubble'}
                noCount={true}
                persons={item.trainers}
                noContentMsg="Keine BTC"
              />
            </div>
          }
          {
            props.compact !== 'staffEvents' &&
            <InlineMenu
              title={
                <MoreVertIcon />
              }
              options={
                [
                  {
                    show: !!(!item.deletedDate && props.onDublicateAsDesign),
                    onClick: props.onDublicate,
                    icon: <SaveIcon />,
                    title: 'Kopie Speichern',
                  },
                  {
                    show: !!(!item.deletedDate && props.onDublicateAsDesign),
                    onClick: props.onDublicateAsDesign,
                    icon: <SaveAltIcon />,
                    title: 'Als Design speichern',
                  },
                  {
                    show: !!(item.deletedDate && props.onUntrash),
                    onClick: props.onUntrash,
                    icon: <RestoreFromTrashIcon />,
                    title: 'Wieder herstellen',
                  },
                  {
                    show: !!props.onRemove,
                    onClick: props.onRemove,
                    icon: <ClearIcon />,
                    title: 'Entfernen',
                  },
                  {
                    show: !!props.onTrash,
                    onClick: props.onTrash,
                    icon: <DeleteIcon />,
                    title: 'Löschen',
                  },
                  
                ]
              }
            />
          }
      </>
    }
    
  </div>;
}
